<template lang="pug">
.contacts-listing__inner
	.contacts-listing__header
		h2.contacts-listing__heading Member Dashboard
		.contacts-listing__intro(v-if="user || district")
			.contacts-listing__greeting(v-if="user", v-html="greeting")
			.contacts-listing__district(v-if="district") District: {{ district }}
	SearchHeader
	AppGrid
</template>

<script>
import AppGrid from "./Grid.vue";
import SearchHeader from "./SearchHeader.vue";

export default {
	name: "GridContainer",
	components: {
		AppGrid,
		SearchHeader,
	},
	props: {
		contacts: Array,
		user: String,
		district: String,
	},
	data() {
		return {};
	},
	computed: {
		greeting() {
			const timeOfDay = new Date().getHours();
			let colloquialism;
			switch (true) {
				case timeOfDay >= 19:
					colloquialism = 'evening';
					break;
				case timeOfDay >= 11:
					colloquialism = 'afternoon';
					break;
				case timeOfDay >= 4:
					colloquialism = 'morning';
					break;
				default:
					colloquialism = 'evening';
					break;
			}
			return `Good ${colloquialism}, <span>${this.user}!</span>`;
		},
	},
	methods: {},
	created() {},
};
</script>

<style scoped lang="scss">
.contacts-listing {
	&__header {
		display: flex;
		flex-direction: column;
		margin-bottom: 1.5rem;
		@include mq(md) {
			margin-bottom: 2rem;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-between;
		}
	}
	&__heading,
	&__sub-heading {
		display: inline-block;
	}
	&__heading {
		margin-bottom: 0.5rem;
		color: $blueOrg;
		@include mq(md) {
		margin-bottom: 0;
		}
	}
	&__intro {
		margin-bottom: 0;
		@include mq(md) {
			text-align: right;
		}
	}
	&__greeting {
		@include fluid(font-size, 1.25rem, 1.375rem);
		line-height: 1.875rem;
		margin-bottom: 0.375rem;
	}
	&__district {
		@include fluid(font-size, 1rem, 1.3125rem);
		line-height: 1.625rem;
	}
}
</style>

<style lang="scss">
.contacts-listing {
	&__greeting {
		span {
			font-weight: 700;
		}
	}
}
</style>